{
  "LOGIN": {
    "TITLE": "Entra al centre de contacte",
    "EMAIL": {
      "LABEL": "Correu electrònic",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Introduïu una adreça de correu electrònic vàlida"
    },
    "PASSWORD": {
      "LABEL": "Contrasenya",
      "PLACEHOLDER": "Contrasenya"
    },
    "API": {
      "SUCCESS_MESSAGE": "Iniciada la sessió amb èxit",
      "ERROR_MESSAGE": "No s'ha pogut connectar amb el servidor Woot. Torna-ho a provar més endavant",
      "UNAUTH": "Nom d'usuari / contrasenya incorrecte. Torna-ho a provar-ho",
      "ACCOUNT_DEACTIVATED": "El teu compte s'ha desactivat. Contacta amb l'administrador.",
      "PASSWORD_LOGIN_DISABLED": "L'inici de sessió amb contrasenya està desactivat per al teu compte. Inicia la sessió amb OAuth (per exemple, Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Inicieu sessió amb Google",
      "BUSINESS_ACCOUNTS_ONLY": "Si us plau, utilitzeu l'adreça de correu electrònic de la vostra empresa per iniciar sessió",
      "NO_ACCOUNT_FOUND": "No hem trobat cap compte per a la vostra adreça de correu electrònic."
    },
    "FORGOT_PASSWORD": "Has oblidat la contrasenya?",
    "CREATE_NEW_ACCOUNT": "Crear un nou compte",
    "SUBMIT": "Inicia la sessió"
  }
}
